import Styled from 'styled-components';

const getBorderColor = props => {
	return props.theme.colors.veryLightGray;
};

export const TaskItemsContainer = Styled.div`
	margin-right: 16px;
`;

export const LoaderContainer = Styled.div`
	width: 100%;
	height:237.19px;
`;
export const Line = Styled.div`
	position: relative;
	height: auto;
	&:last-of-type{
		> div{
			border-bottom: ${props => '1px solid ' + getBorderColor(props)};
		}
	}
`;

export const TableRow = Styled.div`
	outline: none;
	box-sizing: border-box;
	display: flex;
	justify-content: stretch;
	align-items: ${props => (props.header && props.entryRow ? 'center' : 'flex-start')};
`;

export const TableRowHeader = Styled(TableRow)`
	font-size: 9px;
	line-height: 1;
	letter-spacing: 1px;
	color: #a1a1a1;
	font-weight: 500;
	z-index:2;
	${props => (props.stickyTopPosition !== null ? 'position:sticky;' : '')};
	${props => (props.stickyTopPosition !== null ? 'top:' + props.stickyTopPosition + 'px;' : '')};
	${props => (props.stickyTopPosition !== null ? 'background: white' : '')};
	width: 100%;
	height: 30px;
	margin-bottom:1px;
	>div{
		border-radius: 1px;
	}
`;

export const InvoiceItemTableRow = Styled(TableRow)`
	font-size: 13px;
	position: relative;
	color: ${props => props.theme.colors.textGray};
	border: ${props => '1px solid ' + getBorderColor(props)};
	${props => (props.entryRow ? 'border-left: 0px' : '')};
	${props => (props.entryRow ? 'border-right: 0px' : '')};
	border-bottom:none;

	&:hover{
		background:${props => (props.customHoverBackground !== true ? props.theme.colors.mediumGray : 'white')};
		transition: background-color 0.2s ease;
	}
	.clickable{
		cursor: pointer;
		text-decoration: none;
		color:${props => props.theme.colors.textGray};
		outline:none;
		&:hover{
			color:${props => props.theme.colors.hoverPurple};
		}
	}
`;

export const NumberColumn = Styled.span`
	text-align:right;
	flex:1;
	width: 100%;
`;

export const TableHeaderItemContainer = Styled.div`
	align-items: center;
	display: block;
	min-height: 9px;
	width: 100%;
	cursor:${props => props.sortable && 'pointer'};
	text-transform: uppercase;
	text
	p  {
		display: inline-block;
		margin: 0;
	}
	color: ${props => props.sort && props.theme.colors.forecastPurple};
	&:hover {
		color: ${props => props.sortable && props.theme.colors.forecastPurple};
		transition:color 0.2s ease;
	}
	&.sub-header {
		margin-top: 4px;
		margin-bottom: 8px;
		display: flex;
	}
`;

export const SubHeaderItem = Styled.div`
	width: ${props => (props.width !== undefined ? props.width + 'px' : '100%')};
	text-align: right;
	&:not(:first-child){
		padding-left: 16px;
	}
	&.price {
		min-width: 130px;
	}
	&.hours {
		min-width: 80px;
	}
`;

const TableRowItem = Styled.div`
	box-sizing: content-box;
	padding-top: ${props => (!props.header ? '9px;' : '0;')}
	padding-bottom: ${props => (!props.header ? '9px;' : '0;')}
	${props =>
		!props.header && props.customHeight === null
			? 'height: 30px;'
			: props.customHeight !== null
			? `height: ${props.customHeight}px;`
			: ''};	
	padding-left: 16px;
	align-items: center;
	justify-content: ${props => (props.alignRight === true ? 'flex-end' : 'flex-start')};
	${props => (props.alignRight === true ? 'text-align: right;' : '')};
	span {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	/*TODO delete when a propper dropdown has been made*/
	.drop-down-v2, .unfocused-assigned-container, .focused-assigned-container{
		box-sizing:border-box;
	}
	white-space: nowrap;
	/* disabled because dropdwons are not visible */
	/* overflow: hidden;   */
	text-overflow: ellipsis;
	&.price-small {	
		width: 110px;
	}
	&.price {
		width: 110px;
	}
	&.fixed-price {
		width: 110px;
	}
	&.hours {
		min-width: 80px;
	}
	&.project {
		min-width: 150px;
	}
	&.client {
		min-width: 90px;
	}
	&.status {
		width: 102px;
		.drop-down-v2 {
			width: 102px;
		}
	}
	&.date {
		min-width: 85px;
	}
	&.datepicker {
		min-width: 140px;
	}
	&.hours-price-header {
		width: 226px;
	}
	&.description {
		${props => (props.customWidth !== null ? `min-width: ${props.customWidth}px;` : 'min-width: 260px;')};
		&.has-error {
			height: 50px;
		}
	}
	&.quantity  {
		min-width: 70px;
	}
	
	&.price-input  {
		width: 110px;
	}
	
	&.percentage  {
		min-width: 75px;
	}
	
	&.totalPrice  {
		width: 110px;
	}

	&.invoiceId {
		min-width: 29px;

		&:hover{
			${props => (!props.header ? 'cursor: pointer;' : null)}
			${props => (!props.header ? 'color: ' + props.theme.colors.forecastPurple + ';' : null)}
		}
	}

	&.invoiceName {
		min-width: 110px;

		&:hover{
			${props => (!props.header ? 'cursor: pointer;' : null)}
			${props => (!props.header ? 'color: ' + props.theme.colors.forecastPurple + ';' : null)}
		}
	}

	&.name {
		width: 110px;
	}

	&.paid {
		min-width: 100px;
	}

	&.notes {
		justify-content: flex-start;
		min-width: 180px;
	}
	&.export {
		min-width: 80px;
	}
	&.integration-links {
		min-width: 80px;
		justify-content: center;
	}
	&.xero-account {
		min-width: 100px;	
	}
	&.quickbooks-item {
		min-width: 100px;	
	}
	&.economic-product {
		min-width: 130px;	
	}
	&:last-child {
		padding-right: 16px;
	}
	.tooltip-container {
		width: 100%;
	}
	
	&.context-menu{
		&.entry-row {
			padding-left: 0px;
			padding-right: 0px;
			margin-right: 15px;
		}
		>span {
			position: unset;
			margin: auto;
		}
	}
`;

export const StaticTableRowItem = Styled(TableRowItem)`
	min-width: ${props => (props.width !== undefined ? props.width + 'px' : 'auto')};
	max-width: ${props => (props.width !== undefined ? props.width + 'px' : 'auto')};
	width: ${props => (props.width !== undefined ? props.width + 'px' : 'auto')};
	display: flex;
	${props => (props.multiLine === true ? 'flex-direction: column;' : '')}

	&.project {
		display: flex;
		flex-direction: row;
		
		span {
			font-weight: 600;
		}
	}


`;
export const StaticTableRowItemMultiple = Styled(StaticTableRowItem)`
	justify-content: flex-end;
`;

export const InvisibleTableRowItem = Styled(StaticTableRowItem)`
	padding-left:0;
`;

export const GrowableTableRowItem = Styled(TableRowItem)`
	flex: 1;
	display: grid;
	min-width:200px;
	${props => 'width:' + props.width + 'px;'};
	${props => (props.resizing ? 'background:rgba(0, 0, 0, 0.05);' : null)}
	
	div{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	span{
		margin-right:5px;
	}
	 .resizer{
		opacity:${props => (props.resizing ? 1 : 0)};
	}
	&.project, &.invoiceName {
		display: flex;
		flex-direction: ${props => (props.header ? 'column' : 'row')};
		&:not(.entry-row) {
			${props => (props.header !== true ? 'border-right: 1px solid ' + getBorderColor(props) + ';' : '')}
		}
		&.entry-row {
			border-left: 0px;
			padding-left: 0px;
			span {
				margin-right: 0px;
			}
		}
		a {
			margin-right: 16px;
		}
		span {
			font-weight: 600;
		}
	}
`;

export const Container = Styled.div`
	display: flex;
	flex-direction: column;
`;

export const NestedDropdownStyle = Styled.div`
	margin: 5px 0 0 0;
	width: 340px;
`;
export const Row = Styled.div`
	margin-bottom: ${props => (props.last ? '0px' : '24px')};
`;

export const Text = Styled.p`
	margin: 0;
	padding: 0;
	font-size: 13px;
	color: #535353;
	max-width: 702px;
`;

export const TimeRegPopup = Styled.div`
	margin-right:5px;
	height: 16px;// the height of the svg
`;

export const ProjectIndicator = Styled.div`
	flex-grow: 0;
	overflow: inherit !important;
`;
